import request from '@/utils/request';
import { hasMinimumLength } from '@/utils/resultsHelper';
import {
  endpoints, searchConfigEndpoint, searchEndpoint,
} from '@/constants/urls';

const find = (
  query,
  page,
  pageSize,
  queryType,
  filter = {},
  facets = {},
) => request({
  url: endpoints.SEARCH,
  data: {
    query,
    filter,
    page,
    pageSize,
    queryType,
    facets,
  },
  method: 'POST',
});

const searches = (filter, includePrivate, incudeInternal, page, pageSize) => {
  const params = {
    filter,
    page,
    pageSize,
  };

  if (includePrivate !== incudeInternal) {
    if (includePrivate) {
      params.private = true;
    } else {
      params.internal = true;
    }
  }

  return (
    request({
      url: endpoints.SEARCHES,
      params,
      method: 'GET',
    })
  );
};

const search = (code) => request({
  url: searchEndpoint(code),
  method: 'GET',
});

const destroy = ({ code }) => request({
  url: searchEndpoint(code),
  method: 'DELETE',
});

const create = ({
  code,
  name,
  description,
  query,
  type,
  visibility,
  filter,
}) => {
  const data = {
    code,
    name,
    description,
    query,
    type,
    visibility,
    filter,
  };

  if (!hasMinimumLength(data.code)) {
    delete data.code;
  }

  return request({
    url: endpoints.SEARCHES,
    data,
    method: 'POST',
  });
};

const update = ({
  code,
  name,
  description,
  query,
  filter,
  type,
  visibility,
}) => request({
  url: searchEndpoint(code),
  data: {
    name,
    description,
    query,
    filter,
    type,
    visibility,
  },
  method: 'PUT',
});

const config = (code) => (
  request({
    url: searchConfigEndpoint(code),
    method: 'GET',
  })
);

const SearchService = {
  config,
  create,
  destroy,
  find,
  search,
  searches,
  update,
};

export default SearchService;
